export default "__VITE_ASSET__fe333866__"